import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  modal: {
    '.ant-modal-body': {
      height: 700,
      overflowY: 'auto',
      overflowX: 'hidden'
    }
  }
}))
